import { render, staticRenderFns } from "./AdminStandardEmbroideriesEditScreen.vue?vue&type=template&id=32e6817e&scoped=true&"
import script from "./AdminStandardEmbroideriesEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminStandardEmbroideriesEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e6817e",
  null
  
)

export default component.exports